import React from 'react';
import { I18n } from '@aws-amplify/core';
import { WarningOutlined } from '@ant-design/icons';

import { CARGO_HANDLING_LABELS } from '@/components/views/Report/KimLhc/hooks/question-labels';
import { getWarningIconColor } from '@/components/views/Report/KimLhc/utils/helper';
import { KimLhcCategoryKey, type CargoHandlingConditionCategory } from '@/types';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface CargoHandlingCategoryProps {
	data: CargoHandlingConditionCategory;
}

export function CargoHandlingCategory({ data }: Readonly<CargoHandlingCategoryProps>): JSX.Element {
	const warningIconColor = getWarningIconColor(KimLhcCategoryKey.CARGO_HANDLING_CONDITION, data.value);
	
	return (
		<S.AccordionContent>
			<S.FactorItem>
				<S.WarningIcon >
					<WarningOutlined style={{ color: warningIconColor }} />
				</S.WarningIcon>
				<S.FactorText>{I18n.get(CARGO_HANDLING_LABELS[data.value])}</S.FactorText>
			</S.FactorItem>
		</S.AccordionContent>
	);
}
